import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { ReactComponent as IconExternalLink } from '@svg/icon-external-link.svg';
import { scMixinAbsoluteFull } from '@utils/emotion/mixins';

const CardAmbassadorPromotion: React.FC = () => {
  const { t } = useTranslation();

  return (
    <CardBlock>
      <div className="content">
        <strong className="title">{t('home.card.ambassador.promotion.title')}</strong>
        <p className="desc">{t('home.card.ambassador.promotion.desc')}</p>
        <div className="banner-area">
          <a
            href="https://sparkyambassador.oopy.io/"
            target="_blank"
            rel="noopener noreferrer"
            title={t('home.card.ambassador.promotion.banner.alt')}
            className="banner-link"
          >
            <span className="sr-only">{t('home.card.ambassador.promotion.banner.alt')}</span>
          </a>
          {/* {uiStore.canPlayWebm ? (
            <video autoPlay muted loop playsInline>
              <source src="/assets/cards/ambassador_promotion/banner.webm" type="video/webm" />
            </video>
          ) : (
            <img
              src="/assets/cards/ambassador_promotion/banner.gif"
              alt="Welcome Sparky Ambassador"
            />
          )} */}
          <img
            src="/assets/cards/ambassador_promotion/banner.gif"
            alt="Welcome Sparky Ambassador"
          />
        </div>
        <div className="link-area">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfhuNmVk4hyzjRXHJUudY_nXSkRcoz6HfngCNJde60pA2VvuA/viewform"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p className="link-text">
              <i className="icon">
                <IconExternalLink />
              </i>
              <span className="text">{t('home.card.ambassador.promotion.link')}</span>
            </p>
          </a>
        </div>
      </div>
    </CardBlock>
  );
};

const CardBlock = styled.div`
  position: relative;
  width: 350px;
  padding: 22px 23px 22px 22px;
  background-color: ${({ theme }) => theme.colors.secondary.bgColor};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  color: #090909;

  .content {
    .title {
      font-size: 18px;
      line-height: 1.5;
    }

    .desc {
      overflow: hidden;
      margin-top: 14px;
      font-size: 12px;
      line-height: 1.5;
      white-space: pre-wrap;
    }
  }

  .banner-area {
    position: relative;
    aspect-ratio: 306 / 283;

    .banner-link {
      ${scMixinAbsoluteFull};
      z-index: 1;
    }

    video,
    img {
      vertical-align: top;
    }
  }

  .link-area {
    margin-top: 18px;

    a {
      display: inline-block;
      text-decoration: none;
      color: #5100ce;

      &:hover .text {
        text-decoration: underline;
      }
    }

    .link-text {
      margin: 0;
      font-weight: bold;

      .icon {
        svg {
          width: 20px;
          height: 20px;
          vertical-align: top;
        }

        svg path {
          fill: #5100ce;
        }
      }

      .text {
        display: inline-block;
        margin-left: 8px;
        font-size: 15px;
        line-height: 1.2;
        vertical-align: 1px;
      }
    }
  }
`;

export default CardAmbassadorPromotion;
